import translate from "./../services/translation.json";
import "./../assets/scss/aboutUs.scss";
import OurClients from "../components/ourClients/ourClients";
import Universe from "../components/msd-universe/universe";
import UseCases from "./../components/useCases/useCases";
const About = ({ lang }) => {
  return (
    <div className="about-us page-container">
      <h1 className="blue title center">
        {translate[lang].about_page.who_we_are}
      </h1>
      <div className="about-us-container mw-1200">
        <div className="about-us-container-details">
          <p className="who-we-are-desc white">
            {translate[lang].about_page.who_we_are_desc}
          </p>
        </div>
        <div className="about-us-container-img">
          <Universe />
        </div>
      </div>
      <OurClients lang={lang} />
      <UseCases lang={lang} />
      <div className="about-us-more ">
        <h1 className="blue title center">
          {translate[lang].about_page.msd_team}
        </h1>
        <p className="mw-1200">
          {translate[lang].about_page.who_we_are_desc_1}
        </p>
      </div>
    </div>
  );
};

export default About;
